/*TMFL UPDATED TO ALLOW FOR SCROLL ON MOBILE AND DESKTOP*/!function() {
  "use strict";

  const NAV_SEL = "[data-slider-logos]";
  const TEXT_SEL = "[data-slider-text]";
  const SLIDE_SEL = "[data-slide]";
  const IS_SELECTED = "is-selected";
  const IS_INITIALIZED = "is-initialized";
  const FLICKITY_ENABLED = "flickity-enabled";
  const ATTR_SLIDE = "data-slide";
  const ATTR_INDEX = "data-slide-index";

  const AUTOPLAY_MS = 4000;

  if (customElements.get("logos-component")) return;

  customElements.define("logos-component", class extends HTMLElement {
    constructor() {
      super();

      this.slideshowNav = this.querySelector(NAV_SEL);
      this.slideshowText = this.querySelector(TEXT_SEL);

      this.flkty = null;     // text (FlickityFade)
      this.flktyNav = null;  // logos (Flickity)
      this.desktopInterval = null;

      this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState();
      this.bindEvents();
    }

    connectedCallback() {
      this.initSlideshowText();
      this.initSlideshowNav();
    }

    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize);
      if (this.desktopInterval) clearInterval(this.desktopInterval);
      this.desktopInterval = null;

      if (this.flktyNav) {
        try { this.flktyNav.destroy(); } catch(e) {}
        this.flktyNav = null;
      }
      if (this.flkty) {
        try { this.flkty.destroy(); } catch(e) {}
        this.flkty = null;
      }
    }

    // --- helpers -------------------------------------------------------------

    getLogoSlides() {
      return this.slideshowNav ? Array.from(this.slideshowNav.querySelectorAll(SLIDE_SEL)) : [];
    }

    getTextSlides() {
      // IMPORTANT: Select the slide wrapper in the text area (parent of .logos__slide__text)
      return this.slideshowText ? Array.from(this.slideshowText.querySelectorAll(".logos__slide")) : [];
    }

    getOverflowState() {
      // Use real measurements instead of the original 200 * count heuristic.
      if (!this.slideshowNav) return false;

      const slides = this.getLogoSlides();
      if (!slides.length) return false;

      // Ensure layout is measured correctly
      const totalWidth = slides.reduce((sum, el) => sum + (el.getBoundingClientRect().width || el.offsetWidth || 0), 0);
      const containerWidth = this.slideshowNav.getBoundingClientRect().width || this.slideshowNav.offsetWidth || 0;

      return totalWidth > containerWidth + 1; // small tolerance
    }

    clearDesktopInterval() {
      if (this.desktopInterval) clearInterval(this.desktopInterval);
      this.desktopInterval = null;
    }

    clearSelectedClasses() {
      const logos = this.getLogoSlides();
      const texts = this.getTextSlides();
      logos.forEach(el => el.classList.remove(IS_SELECTED));
      texts.forEach(el => el.classList.remove(IS_SELECTED));
    }

    setSelectedByIndex(index) {
      const logos = this.getLogoSlides();
      const texts = this.getTextSlides();

      // remove existing
      const currentLogo = this.slideshowNav && this.slideshowNav.querySelector(`.${IS_SELECTED}`);
      if (currentLogo) currentLogo.classList.remove(IS_SELECTED);

      const currentText = this.slideshowText && this.slideshowText.querySelector(`.${IS_SELECTED}`);
      if (currentText) currentText.classList.remove(IS_SELECTED);

      // set matching logo by data-slide-index
      const nextLogo = this.slideshowNav
        ? this.slideshowNav.querySelector(`[${ATTR_INDEX}="${index}"]`)
        : null;

      if (nextLogo) nextLogo.classList.add(IS_SELECTED);

      // set matching text by data-slide-index (this is the critical fix)
      const nextText = this.slideshowText
        ? this.slideshowText.querySelector(`.logos__slide[${ATTR_INDEX}="${index}"]`)
        : null;

      if (nextText) nextText.classList.add(IS_SELECTED);

      // keep FlickityFade (text) in sync if it exists
      if (this.flkty) {
        try { this.flkty.select(index); } catch(e) {}
      }
    }

    // --- text slider (same as original) -------------------------------------

    initSlideshowText() {
      if (!this.slideshowText) return;

      // Same config as original
      this.flkty = new window.theme.FlickityFade(this.slideshowText, {
        fade: true,
        autoPlay: false,
        prevNextButtons: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        wrapAround: false,
        selectedAttraction: 0.2,
        friction: 0.6,
        draggable: false,
        accessibility: false
      });
    }

    // --- nav slider + mode switching ----------------------------------------

    initSlideshowNav() {
      if (!this.slideshowNav) return;

      // Click behavior: always select corresponding index
      const logoSlides = this.getLogoSlides();
      if (logoSlides.length) {
        logoSlides.forEach((slide) => {
          slide.addEventListener("click", () => {
            const idx = parseInt(slide.getAttribute(ATTR_INDEX), 10);

            // If Flickity is active, let it handle selection too
            const flickityActive = this.slideshowNav.classList.contains(FLICKITY_ENABLED);
            if (this.flkty && Number.isFinite(idx)) this.flkty.select(idx);

            if (flickityActive && this.flktyNav) {
              this.flktyNav.select(idx);
              // If theme is “paused” class is on nav, resume autoplay on click like original did
              if (!this.slideshowNav.classList.contains(IS_SELECTED)) this.flktyNav.playPlayer();
            } else {
              // Desktop mode (no flickity): just toggle classes (CSS handles opacity/anim)
              if (Number.isFinite(idx)) this.setSelectedByIndex(idx);
            }
          });
        });
      }

      this.setSlideshowNavState();
      document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize);
    }

    setSlideshowNavState() {
      if (!this.slideshowNav) return;

      const shouldScroll = this.getOverflowState();
      const flickityActive = this.slideshowNav.classList.contains(FLICKITY_ENABLED);

      if (shouldScroll) {
        // --- SCROLL MODE (Flickity) -----------------------------------------
        this.clearDesktopInterval();

        // match original "is-initialized" usage
        this.slideshowNav.classList.add(IS_INITIALIZED);

        // ensure first selected
        this.setSelectedByIndex(0);

        if (!this.flktyNav) {
          this.flktyNav = new window.theme.Flickity(this.slideshowNav, {
            autoPlay: AUTOPLAY_MS,
            prevNextButtons: false,
            contain: false,
            pageDots: false,
            wrapAround: true,
            watchCSS: true,
            selectedAttraction: 0.05,
            friction: 0.8,
            initialIndex: 0
          });

          // keep text in sync with logo slider (same intent as original)
          if (this.flkty) {
            this.flkty.select(0);
            this.flktyNav.on("change", (idx) => {
              this.setSelectedByIndex(idx);
            });
          }

          // mimic original deactivate behavior
          this.flktyNav.on("deactivate", () => {
            const first = this.slideshowNav.querySelector(SLIDE_SEL);
            if (first) first.classList.add(IS_SELECTED);
            if (this.flkty) this.flkty.select(0);
          });
        } else if (!flickityActive) {
          // if Flickity got deactivated somehow, re-init by forcing select
          try { this.flktyNav.select(0); } catch(e) {}
        }

      } else {
        // --- DESKTOP FADE MODE (no scroll) -----------------------------------
        if (this.flktyNav) {
          try { this.flktyNav.destroy(); } catch(e) {}
          this.flktyNav = null;
        }
        // remove initialized marker
        this.slideshowNav.classList.remove(IS_INITIALIZED);

        // Start the timed highlight loop (logo opacity + matching text)
        const logos = this.getLogoSlides();
        if (!logos.length) return;

        // Determine starting index (keep current if present)
        let current = 0;
        const currentEl = this.slideshowNav.querySelector(`.${IS_SELECTED}[${ATTR_INDEX}]`);
        if (currentEl) {
          const parsed = parseInt(currentEl.getAttribute(ATTR_INDEX), 10);
          if (Number.isFinite(parsed)) current = parsed;
        } else {
          this.setSelectedByIndex(0);
        }

        this.clearDesktopInterval();
        this.desktopInterval = setInterval(() => {
          current = (current + 1) % logos.length;
          this.setSelectedByIndex(current);
        }, AUTOPLAY_MS);
      }
    }

    // --- theme editor block events (unchanged) ----------------------

    onBlockSelect(evt) {
      if (!this.slideshowNav) return;

      const blockId = evt.detail.blockId;
      const slide = this.slideshowNav.querySelector(`[${ATTR_SLIDE}="${blockId}"]`);
      if (!slide) return;

      const idx = parseInt(slide.getAttribute(ATTR_INDEX), 10);
      if (!Number.isFinite(idx)) return;

      if (this.slideshowNav.classList.contains(FLICKITY_ENABLED) && this.flktyNav) {
        this.flktyNav.select(idx);
        this.flktyNav.stopPlayer();
        this.slideshowNav.classList.add(IS_SELECTED);
      } else {
        this.setSelectedByIndex(idx);
      }
    }

    onBlockDeselect() {
      if (!this.slideshowNav) return;

      if (this.slideshowNav.classList.contains(FLICKITY_ENABLED) && this.flktyNav) {
        this.flktyNav.playPlayer();
        this.slideshowNav.classList.remove(IS_SELECTED);
      }
    }

    bindEvents() {
      this.addEventListener("theme:slider-logos:select", (t) => this.onBlockSelect(t.detail.evt));
      this.addEventListener("theme:slider-logos:deselect", () => this.onBlockDeselect());
    }
  });

}();
